import { isCapacitorNative } from '@/core/utils/capacitor.utils';

/**
 * Floating bottom tab bar is Capacitor-native only.
 * Browser desktop/mobile viewports use the sidebar (SidebarTrigger), never this bar.
 * Page layout may still use `useIsMobile()` — do not conflate the two axes.
 *
 * Product rule: on Cap native the bar is **always painted** for shell routes
 * (lists and details). Do not reintroduce cover/hide/sink strategies.
 */
export function shellUsesMobileTabBar(): boolean {
  return isCapacitorNative();
}

/**
 * Fired on `document.documentElement` when Cap tab-bar exposure changes
 * (bootstrap placeholder ↔ main bar). Intercom / clearance tokens re-measure.
 */
export const SHELL_TAB_BAR_CHROME_CHANGE_EVENT = 'shell-tab-bar-chrome-change';

/**
 * Sync `html[data-shell-tab-bar-chrome]`.
 * - `visible` — main Cap floating bar painted; full clearance token
 * - `collapsed` — bootstrap / no-bar shell: safe-area clearance only
 */
export function syncShellTabBarChromeDataset(exposed: boolean): void {
  if (typeof document === 'undefined') return;
  const next = exposed ? 'visible' : 'collapsed';
  if (document.documentElement.dataset.shellTabBarChrome === next) return;
  document.documentElement.dataset.shellTabBarChrome = next;
  document.documentElement.dispatchEvent(
    new Event(SHELL_TAB_BAR_CHROME_CHANGE_EVENT),
  );
}
